import { Dataset } from 'actions/datasetActions';

export const isDashboardDatasetSaved = (datasets: Dataset[]) =>
  !!datasets.find((dataset) => dataset.schema && dataset.query);
